import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import "./registerServiceWorker";
import axios from "axios";
import VueAxios from "vue-axios";
import VeeValidate from "vee-validate";
import NotFound from "./components/NotFound.vue";
import Snotify from "vue-snotify";
import Multiselect from "vue-multiselect";
import VueSweetalert2 from "vue-sweetalert2";
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Dropdown } from 'bootstrap-vue/es/components';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueScrollTo from 'vue-scrollto';
import VModal from 'vue-js-modal';
import Http from './utils/http.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'

import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css'

Vue.component('NotFound', NotFound)
Vue.component('datetime', Datetime);
Vue.use(ElementUI, { locale })
import './assets/main.css'

import snotify from './mixins/snotify';
import filters from './mixins/filters';

// Vue.$http = new Http();
library.add(faUserSecret)

Vue.component('fa', FontAwesomeIcon)

Vue.config.productionTip = false;

Vue.use(VueScrollTo);

Vue.use(VueSweetalert2);

Vue.use(VueAxios, axios);
Vue.use(VeeValidate);

Vue.filter('capitalize', filters.capitalize);

const options = {
  global: {
    oneAtTime: true,
    preventDuplicates: true,
    timeout: 6000
  },
};

Vue.use(Snotify, options);
Vue.mixin(snotify);
Vue.mixin(filters);

Vue.use(require("vue-moment"));
Vue.component("multiselect", Multiselect);
Vue.use(BootstrapVue);
Vue.use(Dropdown);
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

axios.defaults.baseURL = "https://smsc.globaltext.xyz/api_smsc/v1/";

// Vue.prototype.$http = new Http();

function authToken(token) {
  return new Promise(resolve => {
    axios.defaults.headers.common["X-Auth-Token"] = token;
    resolve();
  });
}
const token = localStorage.getItem("user-token");
if (token) {
  authToken(token).then(() => {
    store.dispatch("verifyToken");
  });
}

export const clickOutside = {
  bind: function (el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== "function") {
      const compName = vNode.context.name;
      let warn = `[Vue-click-outside:] provided expression '${binding.expression
        }' is not a function, but has to be`;
      if (compName) {
        warn += `Found in component '${compName}'`;
      }

      console.warn(warn);
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble;
    const handler = e => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;

    // add Event Listeners
    document.addEventListener("click", handler);
  },

  unbind: function (el) {
    // Remove Event Listeners
    document.removeEventListener("click", el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  }
};

Vue.directive("click-outside", clickOutside);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
